import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import CozyAppBar from '@quintoandar/cozy-core/AppBar';
import AppBarMobile from '@quintoandar/cozy-core/AppBar/AppBarMobile';
import ArrowBackIcon from '@quintoandar/cozy-icons/ArrowBack';
import Box from '@quintoandar/cozy-core/Box';
import tokens from '@quintoandar/cozy-theme/tokens/js';
import MessageDescriptorPropType from '@quintoandar/cozy-core/proptypes/Intl';

import Menu from 'components/Menu/Loadable';
import AppBarDesktop from './AppBarDesktop';

const MAX_WIDTH = `(max-width: ${tokens.grid.breakpoint.tablet.minWidth})`;

// Workaround to force rendering of AppBarMobile's title
const forceAppBarTitleDisplay = () => {
  useEffect(() => {
    if (window.matchMedia(MAX_WIDTH).matches) {
      document.body.style.minHeight = 'auto';
    }

    return () => {
      if (window.matchMedia(MAX_WIDTH).matches) {
        document.body.style.minHeight = 'calc(100vh + 200px)';
      }
    };
  }, []);
};

const AppBar = ({ title, tabs, iconBack, onBack, showTitleOnDesktop, subtitle, pageActions }) => {
  const navigationIcon = onBack
    ? {
      icon: iconBack,
      onClick: onBack,
    }
    : undefined;

  const appBarTitle = title && <Box px={1}><FormattedMessage {...title} /></Box>;
  const appBarSubTitle = subtitle && <Box px={1}><FormattedMessage {...subtitle} /></Box>;

  const mobilePageActions = pageActions ? (
    <>
      {pageActions}
      <Menu />
    </>
  ) : (
    <Menu />
  );

  forceAppBarTitleDisplay();

  return (
    <CozyAppBar
      mobile={
        <AppBarMobile
          title={appBarTitle}
          subtitle={appBarSubTitle}
          tabs={tabs}
          navigationIcon={navigationIcon}
          pageActions={mobilePageActions}
        />
      }
      desktop={
        <AppBarDesktop
          title={showTitleOnDesktop && appBarTitle}
          subtitle={appBarSubTitle}
          tabs={tabs}
          navigationIcon={navigationIcon}
          pageActions={pageActions}
        />
      }
    />
  );
};

AppBar.propTypes = {
  title: MessageDescriptorPropType,
  subtitle: MessageDescriptorPropType,
  tabs: PropTypes.node,
  iconBack: PropTypes.elementType,
  onBack: PropTypes.func,
  showTitleOnDesktop: PropTypes.bool,
  pageActions: PropTypes.node,
};

AppBar.defaultProps = {
  iconBack: ArrowBackIcon,
  showTitleOnDesktop: true,
};

export default AppBar;
